import { NewCasinoGameBackend } from 'interfaces/new-casino';
import { Sport } from 'interfaces/sportsbook-data-levels';

export type TSportsGames = Sport[];
export type TSportsGamesState = TSportsGames | null;

export type TSportsGamesResponse = {
  data: { sport: Record<string, Sport> | null };
};

export type TCasinoGamesResponse = [string, NewCasinoGameBackend][];

export enum ESearchElementSearchType {
  ALL = 'all',
  SPORT = 'sport',
  CASINO = 'casino',
  ESPORT = 'esport',
  RACING = 'racing'
}

export type TSearchActions = {
  name?: string;
  gameId: number;
  region?: string;
  eSport?: boolean;
  gameDate: number;
  sportType: string;
  team1_name: string;
  team2_name: string;
  gamesStatus: string;
  competitionId?: number;
  sportTypeAlias: string;
  competitionName: string;
};

export type TSearchSelectedSport = {
  alias: string;
  name: string;
  type: number;
  id?: number | string;
} | null;

export enum ESearchElementEventBusActionTypes {
  CLOSE = 'searchElementClose',
  RESET = 'searchElementReset'
}
